import type { Resolvers, UndoRedoCommandSet } from '../../../../generated';
import { MAX_STACK_SIZE, undoRedoCommandMap } from '../state';

export const resolvers: Resolvers = {
  Mutation: {
    executeUndoCommand: () => {
      const commandMap = undoRedoCommandMap.get('default');
      const commandSet: UndoRedoCommandSet = commandMap.undos[0];
      if (!commandSet) return null;
      const updatedCommandMap = {
        ...commandMap,
        undos: commandMap.undos.slice(1),
        redos: [commandSet, ...commandMap.redos].slice(0, MAX_STACK_SIZE),
        activeCommand: commandSet.undo,
      };
      undoRedoCommandMap.set('default', updatedCommandMap);
      return null;
    },
  },
};
